"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Destroyables = void 0;
var AbstractDestroyable_1 = require("./AbstractDestroyable");
var Burden_1 = require("./Burden");
var Destroyable_1 = require("./Destroyable");
/**
 * Static factory class that provides various methods that create utility Destroyable objects.
 */
var Destroyables = /** @class */ (function () {
    function Destroyables() {
        throw new Error('Destroyables is a static class and cannot be instantiated.');
    }
    /**
     * Creates a single Destroyable that, when destroyed, will destroy all the specified Destroyable objects.
     *
     * @param others the Destroyable objects.
     * @returns {Destroyable}
     */
    Destroyables.aggregate = function (others) {
        if (others.find(function (x) { return !(0, Destroyable_1.isDestroyable)(x); })) {
            throw new Error('aggregate failure: Some of the specified arguments are not Destroyables.');
        }
        return new CallbackDestroyable(function () { return others.forEach(function (x) { return x.destroy(); }); });
    };
    /**
     * Creates a Destroyable that invokes the specified callback when it is destroyed.
     *
     * @param callback the callback
     * @returns {Destroyable}
     */
    Destroyables.callback = function (callback) {
        return new CallbackDestroyable(callback);
    };
    /**
     * Returns an empty Destroyable implementation that does nothing.
     *
     * @returns {Destroyable}
     */
    Destroyables.empty = function () {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return new CallbackDestroyable(function () { });
    };
    /**
     * Creates a Destroyable that resolves the specified Burdens when it is destroyed.
     *
     * @param burdens the burdens
     * @returns {Destroyable}
     */
    Destroyables.fromBurdens = function (burdens) {
        return new CallbackDestroyable(function () { return Burden_1.Burden.resolveAll(burdens); });
    };
    return Destroyables;
}());
exports.Destroyables = Destroyables;
var CallbackDestroyable = /** @class */ (function (_super) {
    __extends(CallbackDestroyable, _super);
    function CallbackDestroyable(callback) {
        var _this = _super.call(this) || this;
        _this.callback = callback;
        return _this;
    }
    CallbackDestroyable.prototype.destroy = function () {
        this.guardDestroyed();
        this.callback();
        _super.prototype.destroy.call(this);
    };
    return CallbackDestroyable;
}(AbstractDestroyable_1.AbstractDestroyable));
